<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title">Rechazar servicio</span>
            <button
                mat-icon-button
                aria-label="Close dialog"
                (click)="dialogRef.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" autocomplete="off" [formGroup]="formRechazar">
            <mat-label class="center">
                A continuación indique el motivo de rechazo del servicio
                <strong>{{ servicio.descripcion }}</strong
                >:
            </mat-label>
            <mat-form-field class="full-width mt-16">
                <mat-label class="center">Motivo </mat-label>
                <input matInput type="text" formControlName="observacion" />
                <mat-hint
                    >{{ observacion.value.length }} / {{ maximo }}</mat-hint
                >
                <mat-error *ngIf="observacion.hasError('required')">
                    Debe ingresar el motivo
                </mat-error>
                <mat-error *ngIf="observacion.hasError('maxlength')">
                    El motivo no puede ser mayor a {{ maximo }} caracteres
                </mat-error>
                <mat-error *ngIf="observacion.hasError('minlength')">
                    Debe ingresar al menos {{ minimo }} caracteres
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formRechazar.value"
            [disabled]="!formRechazar.valid"
        >
            Rechazar
        </button>
    </mat-dialog-actions>
</div>
